import { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/i18n";
import { useTranslation } from "react-i18next";
import "@/index.css";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Boutique from "@/pages/Boutique";
import Produit from "@/pages/Produit";
import Commande from "@/pages/Commande";
import Confirmation from "@/pages/Confirmation";
import LaMaison from "@/pages/LaMaison";
import Admin from "@/pages/Admin";
import Presse from "@/pages/Presse";
import Essayage from "@/pages/Essayage";
import { TryOnProvider } from "@/context/TryOnContext";

function BoundaryFallback({ error }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-noir px-6 text-center">
      <p className="font-serif text-3xl text-ivoire">{t("errors.boundary")}</p>
      <p className="text-sm text-argile">{String(error)}</p>
      <a href="/" className="border border-or px-8 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-or">
        {t("errors.back")}
      </a>
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return <BoundaryFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <CartProvider>
          <TryOnProvider>
          <SmoothScroll />
          <Header />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/produit/:slug" element={<Produit />} />
            <Route path="/commande" element={<Commande />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/la-maison" element={<LaMaison />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/presse" element={<Presse />} />
            <Route path="/essayage" element={<Essayage />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <Toaster
            theme="dark"
            position="top-center"
            style={{ zIndex: 9999 }}
            toastOptions={{
              style: { background: "#121110", border: "1px solid #282522", color: "#F7F5F0" },
            }}
          />
          </TryOnProvider>
        </CartProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
